export const AuthPortatils = ({ auth, handleChange, error }) => {

  return (
                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                Condicions de recepció de l'ordinador portàtil
                                </h4>
                                <p>

                                En el marc del Pla d’educació digital de Catalunya, el Projecte d’acceleració de la
                                transformació digital desplega com una de les intervencions dotar d’equipaments
                                l’alumnat dels centres. L’institut Pompeu Fabra lliurarà als alumnes d’ESO i Batxillerat un
                                ordinador amb les següents característiques: <br/>
                                                                  <br/>

                                    <div className="quadrePortatilAutoritzacions">
                                        Lenovo, 11,6”
                                    </div>

                                                                  <br/>

                                Des del centre es posa a la teva disposició aquest aparell perquè en facis el bon ús
                                necessari per al teu aprenentatge. És responsabilitat teva assegurar-te que es va
                                mantenir en bon estat, conscient que hauràs de tornar-la al final del curs o del teu
                                període d'escolarització a l'institut Cavall Bernat.
                                Recordeu, aquest ordinador no és de la vostra propietat, sinó que l'institut et deixa en
                                préstec.  <br/>


                                  Compromísos:<br/>

                                  <ol>
                                        <li>Portar l'ordinador al centre sempre, per poder treballar adequadament o per revisar-lo.</li> 
                                        <li> Portar l'ordinador carregat de casa. És necessari utilitzar el carregador corresponent a l'ordinador i no cap altre.</li> 
                                        <li> No marcar-lo, ratllar-lo o personalitzar-lo. Cal mantenir la identificació amb un etiquetatge discret que es pugui extreure quan es torni.</li> 
                                        <li> Tornar l'ordinador en perfecte estat al final de la teva escolarització al centre. En concret, heu d'incloure qualsevol accessori que s'hagi facilitat juntament amb l'aparell (adaptador, carregador, etc.). Cal que estigui net, lliure de pols, esquitxades, empremtes,etc.</li> 
                                        <li> La pèrdua de l'ordinador, el carregador o qualsevol trencament es considera una falta greu, amb la conseqüent sanció disciplinària i econòmica.</li> 
                                        <li> Si es detecta qualsevol mal ús, es retirarà l'ordinador. El seu ús és acadèmic, no pas per altres possibilitats fora de les indicacions específiques dels docents.</li> 
                                  </ol>

                                  <input type="checkbox" id="authPortatils" name="authPortatils" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
                                  <label htmlFor="authPortatils"> He llegit i accepto la normativa</label>
                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>
                                </p>


                              </div>
                            </div>

  )
}
